/* ============================================
   GIGLIOTTO TENUTE — Form Validation
   Contact & booking form handling
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  initFormValidation();
});

function initFormValidation() {
  const forms = document.querySelectorAll('[data-validate]');
  
  forms.forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      
      // Clear previous errors
      form.querySelectorAll('.form-error').forEach(err => err.remove());
      form.querySelectorAll('.form-input, .form-textarea, .form-select').forEach(input => {
        input.classList.remove('error');
      });

      let isValid = true;

      // Validate required fields
      form.querySelectorAll('[required]').forEach(field => {
        if (!field.value.trim()) {
          showError(field, 'Questo campo è obbligatorio');
          isValid = false;
        }
      });

      // Validate email
      const emailField = form.querySelector('[type="email"]');
      if (emailField && emailField.value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailField.value)) {
          showError(emailField, 'Inserisci un indirizzo email valido');
          isValid = false;
        }
      }

      // Validate phone
      const phoneField = form.querySelector('[type="tel"]');
      if (phoneField && phoneField.value) {
        const phoneRegex = /^[\d\s+()-]{8,}$/;
        if (!phoneRegex.test(phoneField.value)) {
          showError(phoneField, 'Inserisci un numero di telefono valido');
          isValid = false;
        }
      }

      if (isValid) {
        showSuccess(form);
      }
    });

    // Real-time validation on blur
    form.querySelectorAll('.form-input, .form-textarea, .form-select').forEach(field => {
      field.addEventListener('blur', () => {
        const existingError = field.parentElement.querySelector('.form-error');
        if (existingError) existingError.remove();
        field.classList.remove('error');

        if (field.hasAttribute('required') && !field.value.trim()) {
          showError(field, 'Questo campo è obbligatorio');
        }
      });

      // Remove error on input
      field.addEventListener('input', () => {
        const existingError = field.parentElement.querySelector('.form-error');
        if (existingError) existingError.remove();
        field.classList.remove('error');
      });
    });
  });
}

function showError(field, message) {
  field.classList.add('error');
  const error = document.createElement('span');
  error.className = 'form-error';
  error.textContent = message;
  error.style.cssText = `
    display: block;
    color: var(--color-error);
    font-size: 0.8rem;
    margin-top: 4px;
    animation: fadeIn 0.2s ease;
  `;
  field.parentElement.appendChild(error);

  // Add error border style
  field.style.borderColor = 'var(--color-error)';
  field.addEventListener('focus', () => {
    field.style.borderColor = '';
  }, { once: true });
}

function showSuccess(form) {
  const formType = form.dataset.validate;
  const successDiv = document.createElement('div');
  successDiv.className = 'form-success';
  successDiv.innerHTML = `
    <div style="
      background: linear-gradient(135deg, var(--color-bg-cream), var(--color-bg-light));
      border: 2px solid var(--color-success);
      border-radius: var(--radius-md);
      padding: 2rem;
      text-align: center;
      animation: fadeInUp 0.4s ease;
    ">
      <div style="font-size: 3rem; margin-bottom: 1rem;">✓</div>
      <h3 style="font-family: var(--font-heading); margin-bottom: 0.5rem; color: var(--color-success);">
        ${formType === 'booking' ? 'Prenotazione Inviata!' : 'Messaggio Inviato!'}
      </h3>
      <p style="color: var(--color-text-muted); font-size: 0.95rem;">
        ${formType === 'booking'
          ? 'Ti ricontatteremo a breve per confermare la tua degustazione.'
          : 'Grazie per averci contattato. Ti risponderemo il prima possibile.'}
      </p>
    </div>
  `;

  form.style.display = 'none';
  form.parentElement.appendChild(successDiv);
}
